import i18n from "../../../../i18n";
const SLADueIn = i18n.t('manageAutomation.SLADueIn');
const AssignedTo = i18n.t('manageAutomation.AssignedTo');
const IncidentStatus = i18n.t('manageAutomation.IncidentStatus');
const IncidentID = i18n.t('manageAutomation.IncidentID');
const Priority = i18n.t('manageAutomation.Priority');
const AlertName = i18n.t('manageAutomation.AlertName');
const UpdatedOn = i18n.t('manageAutomation.UpdatedOn');
const Client = i18n.t('manageAutomation.Client');
const AlertCount = i18n.t('manageAutomation.AlertCount');
const IncidentURL = i18n.t('manageAutomation.IncidentURL');
const SysId = i18n.t('manageAutomation.SysId');
const SourceProvider = i18n.t('manageAutomation.SourceProvider');
const SourceType = i18n.t('manageAutomation.SourceType');
const InstanceIP = i18n.t('manageAutomation.InstanceIP');
const Environment = i18n.t('manageAutomation.Environment');
const AccountID = i18n.t('manageAutomation.AccountID');
const SID = i18n.t('manageAutomation.SID');
const InstanceStatus = i18n.t('manageAutomation.InstanceStatus');
const ApplicationName = i18n.t('manageAutomation.ApplicationName');
const InstanceName = i18n.t('manageAutomation.InstanceName');

const INFRA_ALERT_HEADERS = [

    {
        key: 'incidentId',
        header: IncidentID,
        hidden: false,
        optional: false
    },
    {
        key: 'assigned_to',
        header: AssignedTo,
        hidden: false,
        optional: false
    },
    {
        key: 'incidentStatus',
        header: IncidentStatus,
        hidden: false,
        optional: false
    },
    {
        key: 'priority',
        header: Priority,
        hidden: false,
        optional: false
    },
    {
        key: 'SLA_due_in',
        header: SLADueIn,
        hidden: true,
        optional: true
    },
    // {
    //     key: 'host',
    //     header: "Host",
    //     hidden: false,
    //     optional: false
    // },
    {
        key: 'accountId',
        header: AccountID,
        hidden: true,
        optional: true
    },
    {
        key: 'alertName',
        header: AlertName,
        hidden: false,
        optional: false
    },
    {
        key: 'client',
        header: Client,
        hidden: true,
        optional: true
    },
    {
        key: 'alertCount',
        header: AlertCount,
        hidden: false,
        optional: false
    },
    {
        key: 'updatedOn',
        header: UpdatedOn,
        hidden: false,
        optional: false
    },
    //   {
    //     key: 'alertTime',
    //     header: "Alert Time",
    //     hidden: false,
    //     optional: false
    //   },
    {
        key: 'source provider',
        header: SourceProvider,
        hidden: true,
        optional: true
    },
    {
        key: 'source type',
        header: SourceType,
        hidden: false,
        optional: false
    },
    {
        key: 'incidentURL',
        header: IncidentURL,
        hidden: true,
        optional: false
    },
    {
        key: 'sysId',
        header: SysId,
        hidden: true,
        optional: false
    },
    {
        key: 'environment',
        header: Environment,
        hidden: true,
        optional: true
    },
    {
        key: 'instanceName',
        header: InstanceName,
        hidden: false,
        optional: false
    },
    {
        key: 'instanceStatus',
        header: InstanceStatus,
        hidden: true,
        optional: true
    },
    {
        key: 'applicationName',
        header: ApplicationName,
        hidden: true,
        optional: true
    }
];
export default INFRA_ALERT_HEADERS;